/* eslint-disable class-methods-use-this */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/lines-between-class-members */

import { ProtobufError } from "./ProtobufError"

export const dataOffloadSuccessRespString = "COBS-Protobuf"

export type Mode = "COBS_PROTOBUF" | "AT_COMMAND"

/**
 * SansaSerialCommandReader is a class for reading data from a serial port
 * and parsing it into a mode and response type
 * @class
 * @param {SerialPort} port
 * @param {Mode} mode
 * @returns {SansaSerialCommandReader}
 */
export class SansaSerialCommandReader {
  // instance variables
  private port: SerialPort
  private reader: ReadableStreamDefaultReader<Uint8Array> | undefined
  private mode: Mode

  // event handlers
  public onModeChange?: (mode: Mode) => void
  public onAtCommandResponse?: (value: string) => void
  public onErrorResponse?: (err: ProtobufError) => void

  // output buffers
  private serialOutputCOBS: number[] = []
  private serialOutputAtCommand: number[] = []

  /**
   * constructor for SansaSerialCommander
   * @constructor
   * @param {SerialPort} port
   * @param {Mode} mode
   * @returns {SansaSerialCommander}
   */
  constructor(port: SerialPort, mode: Mode = "AT_COMMAND") {
    this.port = port
    this.mode = mode
  }

  /**
   * getMode returns the current mode
   * @returns {Mode}
   */
  public getMode(): Mode {
    return this.mode
  }

  // public handleUnlockResponse

  /**
   * portReadHandlerAtCommand builds @command frames
   *
   * @param {Uint8Array} value
   * @returns {void}
   */
  private portReadHandlerAtCommand(value: Uint8Array): void {
    const valueStr = new TextDecoder().decode(value)
    console.log("valuestr", valueStr)
    if (valueStr.startsWith("@unlock")) {
      this.portReadHandlerUnlockCommand(value)
    }
    // build the serialOutputAtCommand
    else {
      for (let i = 0; i < value.byteLength; i += 1) {
        const data = value.at(i) as number

        // build output
        if (String.fromCharCode(data) !== "\n")
          this.serialOutputAtCommand.push(data)

        // break, we have a message
        if (
          String.fromCharCode(data) === "\n" &&
          this.serialOutputAtCommand.length > 0
        ) {
          const respStr = new TextDecoder().decode(
            new Uint8Array(this.serialOutputAtCommand)
          )

          this.onAtCommandResponse?.(respStr)

          // reset and continue processing for next frame
          this.serialOutputAtCommand = []
        }
      }
    }
  }

  private portReadHandlerUnlockCommand(value: Uint8Array): void {
    let newlineCount = 0
    let startIndex = -1

    // Get bytes after the second newline
    for (let i = 0; i < value.length; i += 1) {
      if (value[i] === 0x0a) {
        // 0x0A is '\n'
        newlineCount += 1
        if (newlineCount === 2) {
          startIndex = i + 1
          break
        }
      }
    }

    if (startIndex === -1) {
      console.error(
        "Could not find second newline character in unlock response"
      )
      return
    }

    // Convert only the bytes after second newline to hex
    const hexString = Array.from(value.slice(startIndex))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")

    const cipher = `@unlock: ${hexString}`
    this.onAtCommandResponse?.(cipher)

    // Reset and continue processing for next frame
    this.serialOutputAtCommand = []
  }

  /**
   * stopPortReader stops the port reader
   *
   * @returns {void}
   */
  public async stopPortReader(): Promise<void> {
    try {
      await this.reader?.cancel()
      // eslint-disable-next-line no-empty
    } catch {}
  }

  /**
   * startPortReader starts the port reader
   *
   * @returns {Promise<void>}
   * @throws {Error} if port reader is undefined
   */
  public async startPortReader(): Promise<void> {
    // console.log("starting port reader")

    this.reader = this.port.readable?.getReader()
    if (this.reader === undefined) {
      console.log("reader is undefined")
      return
    }

    // eslint-disable-next-line no-unreachable-loop
    while (this.reader) {
      try {
        // eslint-disable-next-line no-constant-condition
        while (true) {
          //  console.log("READING CHUNK")
          // eslint-disable-next-line no-await-in-loop
          const { value, done } = await this.reader.read()
          console.log("valueorig", value)
          if (done) {
            break
          }
          // console.log("GOT CHUNK")

          if (this.mode === "AT_COMMAND") {
            // print string from value

            this.portReadHandlerAtCommand(value)
          }
        }
      } catch (error) {
        if (error instanceof ProtobufError) {
          this.onErrorResponse?.(error)
          // reset and continue processing for next frame
          this.serialOutputCOBS = []
          continue
        } else {
          // expected error when reader is released
          if (!(error as any).message.includes("has been released")) {
            console.log(error)
            console.log("reader error, exiting")
          } else {
            // console.log("reader released, exiting")
          }

          break
        }
      }

      this.reader.releaseLock()
    }

    this.port.close()
    // console.log("reader closed")
  }
}
